"use client";

import "@ant-design/v5-patch-for-react-19";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App, ConfigProvider } from "antd";
import viVN from "antd/locale/vi_VN";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import { useState } from "react";
import { AuthProvider } from "@/core/auth/AuthContext";

dayjs.locale("vi");

type AppProvidersProps = Readonly<{
  children: React.ReactNode;
}>;

const theme = {
  token: {
    colorPrimary: "#2f6f3c",
    colorInfo: "#2f6f3c",
    borderRadius: 14,
    fontFamily: "var(--font-be-vietnam-pro), sans-serif"
  }
};

export function AppProviders({ children }: AppProvidersProps) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 60_000,
            retry: 1,
            refetchOnWindowFocus: false
          }
        }
      })
  );

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        {/* Auth.js SessionProvider stays out until /api/auth/* is implemented. See docs/auth-integration.md. */}
        <AntdRegistry>
          <ConfigProvider locale={viVN} theme={theme}>
            <App>{children}</App>
          </ConfigProvider>
        </AntdRegistry>
      </AuthProvider>
    </QueryClientProvider>
  );
}
